import { render, staticRenderFns } from "./OfferName.vue?vue&type=template&id=b64d4cb2"
import script from "./OfferName.vue?vue&type=script&lang=js"
export * from "./OfferName.vue?vue&type=script&lang=js"
import style0 from "./OfferName.vue?vue&type=style&index=0&id=b64d4cb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports